<template>
  <div class="container-fluid px-0" id="profile_section">
    <div v-if="program">
      <div class="program-header position-relative">
        <back-btn to="/dashboard" position="relative" class="mr-auto"></back-btn>
        <div class="program-header__title gold flex-grow-1 text-left text-md-center">
          <i class="fas fa-users pr-1"></i>
          <span v-text="program.title"></span>
          Program Board
        </div>
      </div>
      <hr style="margin-bottom: 0px;">
      <div v-if="program.resources && program.resources !== 'null'" class="row gold text-center">
        <a class="resources-link" :href="program.resources" target="_blank">Resources</a>
      </div>

      <!-- Desktop grid layout -->
      <div class="content-grid d-none d-md-grid" :class="contentGridClass">
        <div v-if="program.video" class="grid-video">
          <ProgramVideo :video="program.video" />
        </div>
        <div v-if="hasChat" class="grid-chat">
          <ProgramChat
            display-type="dsk"
            :active-challenge-id="program.id"
            :challenge="program.title"
            :members="members"
            :totalRows="totalRows"
          />
        </div>
        <div class="grid-members">
          <ProgramMember
            :members="members"
            :isBusy="isBusy"
            :filterOn="filterOn"
          />
        </div>
        <div class="grid-course">
          <ProgramCourse
            :course-id="program.course_id"
            :active-challenge-id="program.id"
            :start-date="program.start_date"
            :challenge-type="program.challenge_type"
          />
        </div>
      </div>

      <!-- Mobile layout -->
      <div class="d-md-none program-mobile-layout">
        <div v-if="program.video" class="mb-2">
          <ProgramVideo :video="program.video" />
        </div>
        <ul class="nav nav-tabs nav-fill">
          <li class="nav-item">
            <a class="nav-link font-weight-bold" :class="{ active: activeTab === 'course' }" @click.prevent="activeTab = 'course'" href="#">Course</a>
          </li>
          <li v-if="hasChat" class="nav-item">
            <a class="nav-link font-weight-bold" :class="{ active: activeTab === 'chat' }" @click.prevent="activeTab = 'chat'" href="#">Chat</a>
          </li>
          <li class="nav-item">
            <a class="nav-link font-weight-bold" :class="{ active: activeTab === 'members' }" @click.prevent="activeTab = 'members'" href="#">Members</a>
          </li>
        </ul>
        <div class="pt-2">
          <div v-show="activeTab === 'course'">
            <ProgramCourse
              :course-id="program.course_id"
              :active-challenge-id="program.id"
              :start-date="program.start_date"
              :challenge-type="program.challenge_type"
            />
          </div>
          <div v-if="hasChat" v-show="activeTab === 'chat'">
            <ProgramChat
              display-type="mbl"
              :active-challenge-id="program.id"
              :challenge="program.title"
              :members="members"
              :totalRows="totalRows"
            />
          </div>
          <div v-show="activeTab === 'members'">
            <ProgramMember
              :members="members"
              :isBusy="isBusy"
              :filterOn="filterOn"
            />
          </div>
        </div>
      </div>
    </div>
<!--    <div v-else-if="error" class="text-center my-2 p-2 gold">-->
<!--      {{ error }}-->
<!--    </div>-->
<!--    <div v-else class="text-center my-2 p-2 gold">-->
<!--      <i class="fas fa-spinner fa-spin fa-2x"></i>-->
<!--      <p>Loading...</p>-->
<!--    </div>-->
  </div>
</template>

<script>
import axios from "@/axios";
import ProgramCourse from '../components/programs/ProgramCourse.vue';
import ProgramMember from "@/components/programs/ProgramMember.vue";
import ProgramChat from "@/components/programs/ProgramChat.vue";
import ProgramVideo from "@/components/programs/ProgramVideo.vue";
import BackBtn from "@/components/BackBtn.vue";

export default {
  name: 'Program',
  components: {
    BackBtn,
    ProgramMember,
    ProgramCourse,
    ProgramChat,
    ProgramVideo,
  },
  data() {
    return {
      program: null,
      members: null,
      error: null,
      isBusy: true,
      filterOn: [],
      totalRows:0,
      activeTab: 'course',
    };
  },
  methods: {
    async getProgram() {
      const response = await axios(`programs/${this.$route.params.challenge_id}`)
        .catch(error => {
          this.error = error.response.status === 404 ? 'Program not found!' : error.response.message;
        })
      this.program = response?.data

      document.title = [this.program?.title || 'Program', 'iAMconnected App'].filter(Boolean).join(' - ');
    },

    async getMembers() {
      this.isBusy = true;
      const response = await axios(`program/${this.$route.params.challenge_id}/members`)
      this.isBusy = false;
      this.members = response.data;
      this.totalRows = response.data.length
    },
  },
  computed: {
    hasChat() {
      return this.program.chat !== 'false' && this.program.chat !== false;
    },
    contentGridClass() {
      if (this.program.video && this.hasChat) return 'layout-both-media';
      if (this.program.video) return 'layout-video-only';
      if (this.hasChat) return 'layout-chat-only';
      return 'layout-no-media';
    },
  },
  mounted() {
    if (this.$route.hash === '#chat') {
      this.activeTab = 'chat'
    }
    this.getProgram();
    this.getMembers();
  },
};
</script>

<style scoped>

.layout-chat-only ::v-deep .wrapper {
  max-height: 730px; /* to match the height with program course */
}
.program-mobile-layout ::v-deep .wrapper {
  max-height: calc(100vh - 170px)
}

/* Header with back button */
.program-header {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 14px;
  padding: 12px 0 8px;
  min-width: 0;
}

.program-header__title {
  font-size: 1.5rem;
  font-weight: 600;
  min-width: 0;
}

@media (max-width: 576px) {
  .program-header__title {
    font-size: 1.1rem;
  }
}


/* Content Grid Layout */
.content-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
}

.content-grid.layout-both-media {
  grid-template-areas:
    "video chat"
    "members course";
}

.content-grid.layout-video-only {
  grid-template-areas:
    "video course"
    "members members";
}

.content-grid.layout-chat-only {
  grid-template-areas:
    "course chat"
    "members members";
}

.content-grid.layout-no-media {
  grid-template-areas:
    "members course";
}

.grid-video { grid-area: video; }
.grid-chat { grid-area: chat; }
.grid-members { grid-area: members; }
.grid-course { grid-area: course; }

.grid-members,
.grid-course {
  display: flex;
  flex-direction: column;
}

.grid-members .panel-container,
.grid-course .panel-container {
  flex: 1;
}

.grid-video {
  display: flex;
  align-items: center;
  justify-content: center;
}

.resources-link {
  margin-bottom: 5px;
  padding-left: 15px;
}

@media (max-width: 991px) {
  .content-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .content-grid.layout-both-media {
    grid-template-areas:
      "video"
      "course"
      "chat"
      "members";
  }

  .content-grid.layout-video-only {
    grid-template-areas:
      "video"
      "course"
      "members";
  }

  .content-grid.layout-chat-only {
    grid-template-areas:
      "course"
      "chat"
      "members";
  }

  .content-grid.layout-no-media {
    grid-template-areas:
      "members"
      "course";
  }
}

/* Desktop grid show/hide — Bootstrap 4 has no d-md-grid utility */
@media (min-width: 768px) {
  .d-md-grid {
    display: grid !important;
  }
}

/* Gold active tab override */
.nav-tabs .nav-link {
  color: #888;
}

.nav-tabs .nav-link.active {
  color: #c8a951;
  border-color: #c8a951 #c8a951 #fff;
}

.nav-tabs .nav-link:hover {
  color: #c8a951;
}
</style>
